import React, { useEffect, useState } from 'react';
import { Grid, Text } from 'elements';
import { Modal, Form, Input, Button, Radio, Space, Checkbox } from 'antd';
import { FormWrapper, Colors, LightGrayColor, SecondaryColor } from 'GlobalStyles';

interface IValue {
  name?: string;
  contact?: string;
  email?: string;
}

const Purchase = ({ isOpenOrder, close }: { isOpenOrder: boolean; close: () => void }) => {
  const [form] = Form.useForm();
  const [method, setMethod] = useState<string>('card');
  const [isAgree, setIsAgree] = useState<boolean>(false);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [values, setValues] = useState<IValue>();
  const [isDisabled, setIsDisabled] = useState<boolean>(true);

  const checkForm = async () => {
    try {
      await form.validateFields();
      if (!isAgree) setIsDisabled(true);
      else setIsDisabled(false);
    } catch (error) {
      setIsDisabled(true);
    }
  };

  const purchase = () => {
    // setIsSubmit(true)
  };

  useEffect(() => {
    if (values) checkForm();
  }, [values, isAgree]);

  if (!isOpenOrder) return null;

  return (
    <Modal visible={isOpenOrder} title='' footer={[]} onCancel={close}>
      <Grid>
        <Grid>
          <Text size='1.8rem' bold>
            구매자 정보
          </Text>
        </Grid>
        <FormWrapper style={{ width: '100%', padding: 0, marginTop: 10 }}>
          <Form
            form={form}
            name='login'
            layout='horizontal'
            className='form-inline'
            initialValues={{ is_remember: true }}
            onValuesChange={(v, a: any) => setValues(a)}
          >
            <Form.Item
              label='주문자'
              name={'name'}
              className='form-item'
              rules={[{ required: true, message: '주문자를 입력해주세요' }]}
            >
              <Input size='large' placeholder='주문자를 입력해주세요' />
            </Form.Item>
            <Form.Item
              label='연락처'
              name={'phone'}
              className='form-item'
              rules={[{ required: true, message: '연락처를 입력해주세요' }]}
            >
              <Input size='large' placeholder='연락처를 입력해주세요' />
            </Form.Item>
            <Form.Item
              label='이메일'
              name={'email'}
              className='form-item'
              rules={[
                { required: true, message: '이메일을 입력해주세요' },
                { type: 'email', message: '이메일 형식이 올바르지 않습니다' },
              ]}
            >
              <Input size='large' placeholder='이메일을 입력해주세요' />
            </Form.Item>
          </Form>
        </FormWrapper>
        <Grid marginTop='10px'>
          <Grid>
            <Text size='1.8rem' bold>
              결제 금액
            </Text>
          </Grid>
          <Grid marginTop='5px' padding='15px 20px' backgroundColor={LightGrayColor} borderRadius='8px'>
            <Grid
              justify='space-between'
              align='center'
              padding='5px'
              style={{ borderBottom: `1px solid ${Colors.grey1}` }}
            >
              <Text bold>상품명</Text>
              <Text bold>5회 패키지</Text>
            </Grid>
            <Grid
              marginTop='5px'
              justify='space-between'
              align='center'
              padding='5px'
              style={{ borderBottom: `1px solid ${Colors.grey1}` }}
            >
              <Text bold>상품 금액</Text>
              <Text bold>150만원</Text>
            </Grid>
            <Grid
              marginTop='5px'
              justify='space-between'
              align='center'
              padding='5px'
              style={{ borderBottom: `1px solid ${Colors.grey1}` }}
            >
              <Text bold>할인 금액</Text>
              <Text bold>10만원</Text>
            </Grid>
            <Grid marginTop='5px' justify='space-between' align='center' padding='5px'>
              <Text bold color={SecondaryColor}>
                총 결제 금액
              </Text>
              <Text bold color={SecondaryColor}>
                140만원
              </Text>
            </Grid>
          </Grid>
        </Grid>
        <Grid marginTop='20px'>
          <Grid>
            <Text size='1.8rem' bold>
              결제 수단
            </Text>
          </Grid>
          <Grid marginTop='5px' padding='15px 20px'>
            <Radio.Group value={method} onChange={(e) => setMethod(e.target.value)}>
              <Space direction='vertical'>
                <Radio value='card'>신용카드</Radio>
                <Radio value='bank'>계좌이체</Radio>
              </Space>
            </Radio.Group>
            <Grid margin='20px 0 0 20px'>
              <Checkbox checked={isAgree} onChange={(e) => setIsAgree(e.target.checked)}>
                <Grid isInline width='calc(100% - 40px)'>
                  결제 내역을 확인하였으며 전자상거래법 및 커리어스텝 정책에 의거하여 환불이 진행되는 것에
                  동의합니다.
                </Grid>
              </Checkbox>
            </Grid>
          </Grid>
        </Grid>
        <Grid marginTop='10px' justify='flex-end'>
          <Button type='primary' size='large' loading={isSubmit} disabled={isDisabled} onClick={purchase}>
            결제하기
          </Button>
        </Grid>
        <Grid marginTop='30px'>
          <Grid justify='space-between'>
            <Grid width='15px'>
              <Text>∙</Text>
            </Grid>
            <Grid width='calc(100% - 15px)'>
              <Text color='#AEAEAE'>결제 취소는 결제 후 7일 이내에만 할 수 있습니다.</Text>
            </Grid>
          </Grid>
          <Grid>
            <Grid width='15px'>
              <Text>∙</Text>
            </Grid>
            <Grid width='calc(100% - 15px)'>
              <Text color='#AEAEAE'>
                수강권은 결제일부터 5년 경과시까지 이용 내역이 없으며 1년 동안 커리어스텝 서비스에 접속하지
                않은 경우 소멸됩니다.
              </Text>
            </Grid>
          </Grid>
          <Grid>
            <Grid width='15px'>
              <Text>∙</Text>
            </Grid>
            <Grid width='calc(100% - 15px)'>
              <Text color='#AEAEAE'>환불을 신청하는 경우, 결제 시 사용한 수단으로 환불해 드립니다.</Text>
            </Grid>
          </Grid>
          <Grid>
            <Grid width='15px'>
              <Text>∙</Text>
            </Grid>
            <Grid width='calc(100% - 15px)'>
              <Grid>
                <Text color='#AEAEAE'>자세한 환불 규정 및 수수료 규정은 아래 링크에서 확인해주세요</Text>
              </Grid>
              <Grid
                cursor='pointer'
                marginTop='4px'
                onClick={() =>
                  window.open('https://www.notion.so/careerstep/0af0f2a2eea3484d9b20d4fba4730d8b')
                }
              >
                <Text width='100%' textDecoration='underline' size='0.8rem' color={Colors.blue}>
                  https://www.notion.so/careerstep/0af0f2a2eea3484d9b20d4fba4730d8b
                </Text>
              </Grid>
              <Grid
                cursor='pointer'
                onClick={() =>
                  window.open('https://www.notion.so/careerstep/5a2227c8f8404396bfda232163686a46')
                }
              >
                <Text width='100%' textDecoration='underline' size='0.8rem' color={Colors.blue}>
                  https://www.notion.so/careerstep/5a2227c8f8404396bfda232163686a46
                </Text>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default Purchase;
